import { createContext, useState, useCallback } from 'react'
import moment from 'moment'

const TRAINING_CALENDAR_TIMESCALE_OPTIONS = [
    { value: 'week', label: 'Weekly Calendar' },
    { value: 'block', label: 'Monthly Calendar' }
]
const DEFAULT_TRAINING_CALENDAR_TIMESCALE = 'block'
const DEFAULT_TIMELINE_START_DATE = moment().startOf('isoWeek').startOf('day')

const CalculateTrainingCalendarDateRange = (trainingCalendarStartDate, timescale) => {
    var dateRange = []
    const startDate = moment(trainingCalendarStartDate).clone().startOf('isoWeek').startOf('day')

    if (timescale === 'week') {
        for (let i = 0; i < 7; i++) {
            dateRange.push(startDate.clone().add(i, 'days'))
        }

        return dateRange
    }

    if (timescale === 'block') {
        for (let i = 0; i < 28; i++) {
            dateRange.push(startDate.clone().add(i, 'days'))
        }

        return dateRange
    }

    console.error(timescale + ' not supported yet!! Returning empty date range.')
    return dateRange
}

export const TrainingCalendarContext = createContext()

export const TrainingCalendarContextProvider = ({ children }) => {

    const [trainingCalendarDateRange, setTrainingCalendarDateRange] = useState(CalculateTrainingCalendarDateRange(DEFAULT_TIMELINE_START_DATE, DEFAULT_TRAINING_CALENDAR_TIMESCALE))
    const [trainingCalendarTimescale, setTrainingCalendarTimescale] = useState(DEFAULT_TRAINING_CALENDAR_TIMESCALE)

    const UpdateTrainingCalendarDateRange = useCallback((date) => {
        const monday = moment(date).clone().startOf('isoWeek').startOf('day')
        setTrainingCalendarDateRange(CalculateTrainingCalendarDateRange(monday, trainingCalendarTimescale))
    }, [trainingCalendarTimescale])

    const UpdateTrainingCalendarTimescale = useCallback((timescale) => {
        setTrainingCalendarTimescale(timescale)

        setTrainingCalendarDateRange((currentDateRange) => {
            const startDate = currentDateRange[0] ?? DEFAULT_TIMELINE_START_DATE
            const monday = moment(startDate).clone().startOf('isoWeek').startOf('day')
            return CalculateTrainingCalendarDateRange(monday, timescale)
        })
    }, [])
    
    const TrainingCalendarContextData = {
        trainingCalendarDateRange,
        trainingCalendarTimescale,
        trainingCalendarTimescaleOptions: TRAINING_CALENDAR_TIMESCALE_OPTIONS,
        UpdateTrainingCalendarDateRange,
        UpdateTrainingCalendarTimescale
    }

    return (
        <TrainingCalendarContext.Provider value={TrainingCalendarContextData}>
            {children}
        </TrainingCalendarContext.Provider>
    )
}
